import { useLayoutEffect } from 'react';

export const useMeasureScrollbars = () => {
  useLayoutEffect(() => {
    /**
     * This works because of the scrollbar-gutter: stable;
     * property set in style-nofonts.css
     */
    const doc = document.documentElement;
    const scrollbarWidth = window.innerWidth - doc.clientWidth;
    document.documentElement.style.setProperty(
      '--scrollbar-width',
      `${scrollbarWidth}px`
    );
  }, []);
};
